const Img_tiktok = () => {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20_88)">
        <path
          d="M13.0251 0.0300098C14.3351 0.0100098 15.6351 0.0200098 16.9351 0.0100098C17.0151 1.54001 17.5651 3.10001 18.6851 4.18001C19.8051 5.29001 21.3851 5.80001 22.9251 5.97001V10C21.4851 9.95001 20.0351 9.65001 18.7251 9.03001C18.1551 8.77001 17.6251 8.44001 17.1051 8.10001C17.0951 11.02 17.1151 13.94 17.0851 16.85C17.0051 18.25 16.5451 19.64 15.7351 20.79C14.4251 22.71 12.1551 23.96 9.82512 24C8.39512 24.08 6.96512 23.69 5.74512 22.97C3.72512 21.78 2.30512 19.6 2.09512 17.26C2.07512 16.76 2.06512 16.26 2.08512 15.77C2.26512 13.87 3.20512 12.05 4.66512 10.81C6.32512 9.37001 8.64512 8.68001 10.8151 9.09001C10.8351 10.57 10.7751 12.05 10.7751 13.53C9.78512 13.21 8.62512 13.3 7.75512 13.9C7.12512 14.31 6.64512 14.94 6.39512 15.65C6.18512 16.16 6.24512 16.72 6.25512 17.26C6.49512 18.9 8.07512 20.28 9.75512 20.13C10.8751 20.12 11.9451 19.47 12.5251 18.52C12.7151 18.19 12.9251 17.85 12.9351 17.46C13.0351 15.67 12.9951 13.89 13.0051 12.1C13.0151 8.07001 12.9951 4.05001 13.0251 0.0300098Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="clip0_20_88">
          <rect width={24} height={24} transform="translate(0.5 0.0100098)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Img_tiktok
